import React from "react";
import { GraduationCap, Users, Camera, PartyPopper, ArrowRight } from "lucide-react";
import { Reveal } from "../Reveal";
import { useForm } from "../../context/FormContext";

const WAYS = [
  { icon: GraduationCap, bg: "bg-butter", title: "Workshops & Masterclasses", copy: "Teach a class, run a training, or host a hands-on creative workshop in a room that adapts to you.", use: "Workshop or Class" },
  { icon: Users, bg: "bg-sky", title: "Team Training & Gatherings", copy: "Gather your team for offsites, trainings, and planning sessions with flexible classroom seating.", use: "Workshop or Class" },
  { icon: Camera, bg: "bg-blush", title: "Photo & Video Shoots", copy: "A clean, well-lit content creation studio with a mirrored wall and open floor for shoots.", use: "Curated Brand Experience" },
  { icon: PartyPopper, bg: "bg-lavender", title: "Creative Community Events", copy: "Bring people together around an idea — curated brand experiences, showcases, and meetups.", use: "Curated Brand Experience" },
];

export function WaysToUse() {
  const { requestAvailability } = useForm();
  return (
    <section id="ways" className="bg-cream py-20 md:py-28">
      <div className="max-w-[1320px] mx-auto px-5 md:px-8">
        <Reveal><span className="sticker">Ways to use the space</span></Reveal>
        <Reveal delay={0.05}>
          <h2 className="display text-berry text-4xl sm:text-5xl md:text-6xl mt-6 max-w-2xl">What will you create here?</h2>
        </Reveal>
        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {WAYS.map((w, i) => (
            <Reveal key={w.title} delay={i * 0.08} y={24}>
              <div className={`card-soft ${w.bg} p-7 h-full flex flex-col`} data-testid={`way-${i}`}>
                <div className="w-12 h-12 rounded-full bg-cream border-2 border-charcoal flex items-center justify-center mb-5">
                  <w.icon size={22} strokeWidth={2} className="text-berry" />
                </div>
                <h3 className="font-serif text-xl text-charcoal leading-tight">{w.title}</h3>
                <p className="mt-3 text-sm text-charcoal/75 flex-1">{w.copy}</p>
                <button
                  onClick={() => requestAvailability({ use: w.use })}
                  data-testid={`way-cta-${i}`}
                  className="mt-5 inline-flex items-center gap-1.5 font-serif text-berry hover:gap-2.5 transition-all"
                >
                  Inquire <ArrowRight size={16} strokeWidth={2} />
                </button>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
